import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      light: {
        primary: "#2039CC",
        secondary: "#080E33",
        accent: "#5E948E",
        error: "#FF5252",
        info: "#2196F3",
        success: "#7BCF7D",
        warning: "#FE9F0D"
      },
      dark: {
        primary: "#0D5EDE",
        secondary: "#192DA1",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#7BCF7D",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: { pt },
    current: "pt"
  }
});
